/* Al Fagr - premium product page */
(function () {
  'use strict';
  var D = document;
  var $ = function (s, r) { return (r || D).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); };

  function init(root) {
    var F = window.FagrShop; if (!F || root.__pd) return;
    root.__pd = 1;
    var P = JSON.parse($('script[data-pd-p]', root).textContent);
    var inv = {}; try { inv = JSON.parse($('script[data-pd-inv]', root).textContent); } catch (e) {}
    var st = { color: F.firstColor(P), size: null };
    var qv = +(new URLSearchParams(location.search).get('variant') || 0);
    var v0 = P.v.filter(function (v) { return v.id === qv; })[0];
    if (v0) { if (P.ci >= 0) st.color = v0.o[P.ci]; if (P.si >= 0) st.size = v0.o[P.si]; }
    var rail = $('[data-pd-rail]', root), slides = rail ? $$('.fg-pd__slide', rail) : [];
    var thumbs = $$('[data-pd-th]', root), dots = $$('[data-pd-dot]', root);
    var atc = $('[data-pd-atc]', root), buy = $('[data-pd-buy]', root), qtyEl = $('[data-pd-qty]', root);
    var price = $$('[data-pd-price]', root), was = $$('[data-pd-was]', root), save = $('[data-pd-save]', root), note = $('[data-pd-note]', root);
    var sticky = $('[data-pd-sticky]');
    var cur = 0, lock = 0;
    var rtl = function () { return getComputedStyle(rail).direction === 'rtl'; };

    function mark(i) {
      cur = i;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      dots.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
    }
    function go(i) {
      if (!slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      lock = Date.now();
      rail.scrollTo({ left: (rtl() ? -1 : 1) * i * rail.clientWidth, behavior: 'smooth' });
      mark(i);
    }
    function goImg(id) {
      for (var i = 0; i < slides.length; i++) if (+slides[i].getAttribute('data-iid') === id) { go(i); return true; }
      return false;
    }
    /* image -> colour map: alt "color: X" or variant image; following images inherit the colour of the previous one */
    var multi = P.ci >= 0 && P.opt[P.ci].v.length > 1;
    var cvals = P.ci >= 0 ? P.opt[P.ci].v : [];
    var sc = slides.map(function (s) {
      var id = +s.getAttribute('data-iid'); if (!id) return null;
      var im = s.querySelector('img'), m = im && /^\s*colou?r\s*:\s*(.+?)\s*$/i.exec(im.getAttribute('alt') || '');
      if (m) { var k = F.slug(m[1]); var hit = cvals.filter(function (c) { return F.slug(c) === k; })[0]; if (hit) return hit; }
      return F.colorOfImg(P, id);
    });
    if (multi) {
      var lastC = null, firstC = null;
      sc.forEach(function (c, i) {
        if (c) { lastC = c; if (!firstC) firstC = c; }
        else if (+slides[i].getAttribute('data-iid')) sc[i] = lastC;
      });
      sc.forEach(function (c, i) { if (!c && +slides[i].getAttribute('data-iid')) sc[i] = firstC; });
    }
    function goColor(c) {
      var k = -1, vi = F.imgOfColor(P, c);
      if (vi) for (var j = 0; j < slides.length; j++) if (+slides[j].getAttribute('data-iid') === vi && sc[j] === c) { k = j; break; }
      if (k >= 0) { while (k > 0 && sc[k - 1] === c) k--; }
      else k = sc.indexOf(c);
      if (k >= 0) { go(k); return; }
      var id = F.imgOfColor(P, c); if (id) goImg(id);
    }
    function pickFromSlide(i) {
      if (!multi) return;
      var c = sc[i];
      if (c && c !== st.color) { st.color = c; picker.render(); sync(); }
    }
    function show(i) { go(i); pickFromSlide(Math.max(0, Math.min(slides.length - 1, i))); }
    var picker = F.Picker(P, st, function (kind) {
      if (kind === 'color') goColor(st.color);
      sync();
    });
    $('[data-pd-pick]', root).appendChild(picker.el);

    function sync() {
      var v = picker.variant();
      if (!v) return;
      var disc = v.c > v.p;
      price.forEach(function (e) { e.textContent = F.money(v.p); });
      was.forEach(function (e) { e.textContent = disc ? F.money(v.c) : ''; e.hidden = !disc; });
      if (save) { save.hidden = !disc; if (disc) save.textContent = '-' + Math.round((v.c - v.p) * 100 / v.c) + '%'; }
      var ok = v.a;
      [atc, buy, $('[data-pd-satc]')].forEach(function (b) { if (b) b.disabled = !ok; });
      if (atc) $('span', atc).textContent = ok ? F.T('Add to cart', 'أضف للسلة') : F.T('Sold out', 'نفدت الكمية');
      var q = inv[v.id];
      if (note) {
        if (!ok) note.textContent = '';
        else if (q != null && q > 0 && q <= 5) note.textContent = F.T('Only ' + q + ' left in stock', 'متبقي ' + q + ' قطع فقط');
        else note.textContent = F.T('In stock — ships within 24h', 'متاح — يشحن خلال 24 ساعة');
        note.classList.toggle('is-low', ok && q != null && q > 0 && q <= 5);
      }
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
    }
    function qty() { return Math.max(1, +(qtyEl && qtyEl.value) || 1); }
    function flash(b, txt, cls) {
      if (!b) return; var s = $('span', b) || b, old = s.__o || s.textContent; s.__o = old;
      s.textContent = txt; b.classList.add(cls);
      clearTimeout(b.__t); b.__t = setTimeout(function () { s.textContent = old; b.classList.remove('is-ok', 'is-err'); s.__o = null; }, 1800);
    }
    function add(b) {
      var v = picker.variant(); if (!v || !v.a) return;
      b.disabled = true;
      F.Cart.add([{ id: v.id, quantity: qty() }]).then(function () { flash(b, F.T('Added ✓', 'تمت الإضافة ✓'), 'is-ok'); })
        .catch(function (e) { flash(b, (e && e.message) || F.T('Could not add', 'تعذّرت الإضافة'), 'is-err'); })
        .then(function () { b.disabled = false; });
    }
    if (atc) atc.addEventListener('click', function () { add(atc); });
    var satc = $('[data-pd-satc]'); if (satc) satc.addEventListener('click', function () { add(satc); });
    if (buy) buy.addEventListener('click', function () {
      var v = picker.variant(); if (!v || !v.a) return; buy.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: qty() }] }) })
        .then(function (r) { if (!r.ok) throw 0; location.href = '/checkout'; }).catch(function () { buy.disabled = false; });
    });
    $$('[data-pd-q]', root).forEach(function (b) { b.addEventListener('click', function () { qtyEl.value = Math.max(1, qty() + (+b.getAttribute('data-pd-q'))); }); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    dots.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var pv = $('[data-pd-prev]', root), nx = $('[data-pd-next]', root);
    if (pv) pv.addEventListener('click', function () { show(cur - 1); });
    if (nx) nx.addEventListener('click', function () { show(cur + 1); });
    if (rail) rail.addEventListener('scroll', function () {
      clearTimeout(rail.__s);
      rail.__s = setTimeout(function () {
        var i = Math.round(Math.abs(rail.scrollLeft) / (rail.clientWidth || 1));
        mark(i);
        if (Date.now() - lock > 500) pickFromSlide(i);
      }, 90);
    }, { passive: true });
    $$('[data-pd-acc] > button', root).forEach(function (b) {
      b.addEventListener('click', function () { var a = b.parentNode; var o = a.classList.toggle('is-open'); b.setAttribute('aria-expanded', o); });
    });
    var sg = $('[data-pd-sg]', root), sgm = $('[data-pd-sgm]');
    if (sg && sgm) { sg.addEventListener('click', function () { sgm.classList.add('is-open'); }); sgm.addEventListener('click', function (e) { if (e.target.closest('[data-pd-x]')) sgm.classList.remove('is-open'); }); }
    if (window.FagrRecs) FagrRecs.load($('[data-pd-recs]', root), P.id, { limit: 6 });
    if (sticky && 'IntersectionObserver' in window && atc) {
      new IntersectionObserver(function (es) { sticky.classList.toggle('is-on', !es[0].isIntersecting && es[0].boundingClientRect.top < 0); }).observe(atc);
    }
    mark(0); picker.render(); sync();
    if (v0 && P.ci >= 0) setTimeout(function () { goColor(st.color); }, 60);
  }
  function boot() { $$('[data-fg-pd]').forEach(init); }
  if (D.readyState !== 'loading') boot(); else D.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', boot);
})();
